import { render, staticRenderFns } from "./SupportStudios.vue?vue&type=template&id=259768a4&scoped=true&"
import script from "./SupportStudios.vue?vue&type=script&lang=js&"
export * from "./SupportStudios.vue?vue&type=script&lang=js&"
import style0 from "./SupportStudios.vue?vue&type=style&index=0&id=259768a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259768a4",
  null
  
)

export default component.exports